var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product__add-to-cart" }, [
    _c("div", { staticClass: "counter" }, [
      _c(
        "button",
        {
          staticClass: "counter__btn counter__btn--less",
          class: { "counter__btn--small": _vm.counterMode == "small" },
          attrs: {
            disabled: _vm.count <= 1 || !_vm.$store.getters.changesAllowed
          },
          on: {
            click: function($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.decrease()
            }
          }
        },
        [
          _c("span", { staticClass: "screen-reader-text" }, [
            _vm._v(_vm._s(_vm.$modeoL10n.decrease))
          ])
        ]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.count,
            expression: "count"
          }
        ],
        staticClass: "counter__amount",
        class: { "counter__amount--small": _vm.counterMode == "small" },
        attrs: {
          type: "number",
          "aria-label": _vm.$modeoL10n.amount,
          disabled: !_vm.$store.getters.changesAllowed
        },
        domProps: { value: _vm.count },
        on: {
          keydown: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault()
          },
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.update(_vm.count)
          },
          change: function($event) {
            return _vm.emitChange()
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.count = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "counter__btn counter__btn--more",
          class: { "counter__btn--small": _vm.counterMode == "small" },
          attrs: {
            disabled:
              (_vm.maxCount && _vm.count >= _vm.maxCount) ||
              !_vm.$store.getters.changesAllowed
          },
          on: {
            click: function($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.add()
            }
          }
        },
        [
          _c("span", { staticClass: "screen-reader-text" }, [
            _vm._v(_vm._s(_vm.$modeoL10n.increase))
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e971eb6", { render: render, staticRenderFns: staticRenderFns })
  }
}